// Label color palette — matches Android's LabelColors.PRESET, in order.
export const LABEL_PRESET_COLORS = [
  "#EF4444", // red
  "#F97316", // orange
  "#EAB308", // amber
  "#22C55E", // green
  "#10B981", // emerald
  "#06B6D4", // cyan
  "#3B82F6", // blue
  "#6366F1", // indigo
  "#8B5CF6", // violet
  "#EC4899", // pink
  "#A3A3A3", // neutral
  "#78716C", // stone
];

// Android's LabelData.DEFAULT_COLOR.
export const DEFAULT_LABEL_COLOR = "#7C8DB5";

export const HEX_RE = /^#([0-9A-Fa-f]{6})$/;
